module.exports = " <div class=message_session _v-304d792a=\"\"> <message-view _v-304d792a=\"\"></message-view> <send-panel _v-304d792a=\"\"></send-panel> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-304d792a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/body/session/MessageSession.vue
 ** module id = 341
 ** module chunks = 2
 **/